<script setup lang="ts">
defineOptions({ name: 'App' })
</script>

<template>
  <RouterView />
</template>
